import { SelectMenu } from '@dtsl/react';
import { useAppState } from '../../../state';
import { useTranslation } from 'react-i18next';
import useDevices from '../../../hooks/useDevices/useDevices';

export default function AudioOutputList() {
  const { audioOutputDevices } = useDevices();
  const { activeSinkId, setActiveSinkId } = useAppState();
  const { t } = useTranslation();
  const activeOutputLabel = audioOutputDevices.find((device) => device.deviceId === activeSinkId)?.label;

  const options = audioOutputDevices.map((device) => ({
    key: device.deviceId,
    value: device.deviceId,
    label: device.label,
  }));

  const currentValue = [
    {
      key: activeSinkId,
      value: activeSinkId,
      label: activeOutputLabel,
    },
  ];

  return (
    <div className="inputSelect">
      {audioOutputDevices.length > 1 ? (
        <SelectMenu
          label={t('ROOM.SPEAKER_SELECT')}
          options={options}
          onSelect={(selected: { value: string }) => {
            setActiveSinkId(selected.value);
          }}
          value={currentValue}
        />
      ) : (
        <>
          <p className="sib-typo_text-body--bold">{t('ROOM.SPEAKER_SELECT')}</p>
          <p className="sib-typo_text-body">{activeOutputLabel || t('ROOM.SPEAKER_NO_SELECT')}</p>
        </>
      )}
    </div>
  );
}
